import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import { createMap, deliveryAgentIcon } from '../../../utils/leafletConfig';

const PolylineMap = ({ initialCoordinates }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);

  useEffect(() => {
    // Initialize map
    if (mapRef.current && !mapInstanceRef.current) {
      mapInstanceRef.current = createMap(mapRef.current);
    }
    
    return () => {
      // Cleanup on unmount
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!mapInstanceRef.current || !initialCoordinates) return;

    // Clear existing markers
    markersRef.current.forEach(marker => {
      mapInstanceRef.current.removeLayer(marker);
    });
    markersRef.current = [];

    // Add new markers
    if (initialCoordinates.length > 0) {
      initialCoordinates.forEach((item, index) => {
        const lat = Number(item.location_latitude);
        const lng = Number(item.location_longitude);
        
        if (!isNaN(lat) && !isNaN(lng)) {
          const marker = L.marker([lat, lng], { icon: deliveryAgentIcon })
            .bindPopup(`
              <div style="font-family: 'Segoe UI', sans-serif; max-width: 250px;">
                <div style="background: linear-gradient(135deg, #00008B, #4169E1); color: white; padding: 8px 12px; margin: -8px -12px 8px -12px; border-radius: 4px 4px 0 0;">
                  <strong style="font-size: 14px;">📱 ${item.RegisteredPhoneNumber1}</strong>
                </div>
                <div style="padding: 4px 0;">
                  <div style="margin-bottom: 6px;">
                    <span style="color: #666; font-size: 12px;">📍 Location:</span><br/>
                    <span style="font-size: 13px; color: #333;">${item.location_address || 'N/A'}</span>
                  </div>
                  <div style="background: #f5f5f5; padding: 6px; border-radius: 4px; font-size: 11px; color: #666;">
                    <strong>Coordinates:</strong> ${item.location_latitude}, ${item.location_longitude}
                  </div>
                  <div style="margin-top: 6px; font-size: 11px; color: #52c41a;">
                    ● Online & Active
                  </div>
                </div>
              </div>
            `, {
              maxWidth: 280,
              className: 'professional-popup'
            })
            .addTo(mapInstanceRef.current);
          
          markersRef.current.push(marker);
        }
      });

      // Fit map to show all markers
      if (markersRef.current.length > 0) {
        const group = new L.featureGroup(markersRef.current);
        mapInstanceRef.current.fitBounds(group.getBounds(), { 
          padding: [20, 20],
          maxZoom: 15
        });
      }
    }
  }, [initialCoordinates]);

  return (
    <div 
      ref={mapRef}
      style={{
        width: '100%',
        height: '450px',
        border: '1px solid #e8e8e8',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden'
      }}
    />
  );
};

export default PolylineMap;